// views
import UserProfileContainer from 'pages/UserProfile/UserProfileContainer';
import AppImagesContainer from 'pages/AppImages/AppImagesContainer';
const routes = {
  userProfile: {
    path: '/app/user-profile',
    component: UserProfileContainer,
    navbarName: 'User Profile'
  },
  'app-images': {
    path: '/feature/app-images',
    component: AppImagesContainer,
    navbarName: 'App Images'
  },
  // Short-lived shim: the split-API Session Viewer was QA'd at
  // /app/store-explorer-v3 before being promoted onto store-explorer-v2. Keeps
  // links QA saved during that period working. Safe to delete once none remain.
  'store-explorer-v3-legacy': {
    redirect: true,
    path: '/app/store-explorer-v3',
    to: '/app/store-explorer-v2'
  }
};

export default routes;
